import axios from 'axios'

import {getQuery} from "@common-helpers/url-helper"

const getSubParameters = () => {
    let getParametersStr = localStorage.getItem('get_props'),
        regexp = /sub\d+=/g,
        SubParamsList = {}

    let result;

    while (result = regexp.exec(getParametersStr)) {

        const GETParameter = result[0].replace('=', '')
        let foundedGet = getQuery().get(GETParameter)

        if (foundedGet) {
            SubParamsList[GETParameter] = foundedGet
        }
    }

    return SubParamsList

}

export const sendEventToArbitration = (page_id = 0, event = 'not-described-event') => {

    const click_id = localStorage.getItem('click_id'),
          landing_code = localStorage.getItem('landingId') || 0,
          flowid = localStorage.getItem('flowid')

    if (click_id) {

        let sub = {},
            eventData = {}

        if (event === 'INIT') {
            sub = getSubParameters();
        }

        if(flowid && flowid !== 'null' && flowid !== ''){
            eventData = {
                click_id,
                flowid,
                landing_code,
                page_id,
                action_type: event,
                ...sub
            }
        } else {
            eventData = {
                click_id,
                landing_code,
                page_id,
                action_type: event,
                ...sub
            }
        }
        
        const formData = new FormData()

        formData.append(`eventDataJson`, JSON.stringify(eventData))

        axios.post('/save-user-event-data-from-landing', formData, {
            headers: {
                'x-requested-with': 'XMLHttpRequest'
            }
        })

    }

}